import React, { useState, useContext, useEffect, } from "react";
import { motion } from "framer-motion";
import { AppContext } from "../../context/AppContext";
import "./Sidebar.styles.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { Button } from "@mui/material";

// react icons import
import { FiLogOut } from "react-icons/fi";
import { handleInvalidToken } from "../../AuthUtils";
import { RiDashboardHorizontalFill } from "react-icons/ri";
import { FaHandHoldingUsd, FaTools } from "react-icons/fa";
import { FaDesktop, FaAngleRight } from "react-icons/fa6";
import { MdOutlineSupportAgent } from "react-icons/md";
import { GiUpgrade } from "react-icons/gi";
import { GiBookCover } from "react-icons/gi";

import { BiSolidMessageSquareDetail } from "react-icons/bi";
import { PiImagesBold } from "react-icons/pi";
import { FaBookOpen } from "react-icons/fa6";
import { MdWork } from "react-icons/md";
import { FaStore } from "react-icons/fa";
import { SiAudiobookshelf } from "react-icons/si";
import { FaGifts } from "react-icons/fa";
import { FaWandSparkles } from "react-icons/fa6";
import { RiTeamFill } from "react-icons/ri";
import { TbCloudStorm } from "react-icons/tb";
import { BsPersonWorkspace } from "react-icons/bs";
import { CiGift } from "react-icons/ci";
import { IoDocuments } from "react-icons/io5";
import { GiSpellBook } from "react-icons/gi";

// icons data import from other local file
import icons from '../../icon'
import { toast } from "react-toastify";

const Sidebar = () => {
	const { isSidebarOpen, setIsSidebarOpen, isSmallScreen, clearPermissions, packageAccess, features } = useContext(AppContext);
	const [activeTab, setActiveTab] = useState(null);
	const [activeMenu, setActiveMenu] = useState(null);
	const [suiteURL, setSuiteURL] = useState('');
	const [appoitmentURL, setAppoitmentURL] = useState('');
	const [storeURL, setStoreURL] = useState('');
	const [workerURL, setWorkerURL] = useState('');

	const navigate = useNavigate();
	const pathname = useLocation().pathname;
	const handleLogout = () => {
		Swal.fire({
			title: "Are you sure you want to log out?",
			icon: "warning",
			showDenyButton: true,
			confirmButtonText: "Yes, log me out",
			denyButtonText: "No, stay logged in",
		}).then((result) => {
			if (result.isConfirmed) {
				toast.success("You have been successfully logged out.");
				// Swal.fire(
				// 	"Logged out",
				// 	"You have been successfully logged out.",
				// 	"success"
				// );
				clearPermissions();
				handleInvalidToken(navigate);
			} else if (result.isDenied) {
				toast.info("You chose to stay logged in.");
			//	Swal.fire("Stayed logged in", "You chose to stay logged in.", "info");
			}
		});
	};

	useEffect(() => {
		var email = localStorage.getItem('email');
		setSuiteURL('https://primebeastai.com/bookflowai-ai-suite-edition?user=' + btoa(email));
		setAppoitmentURL('https://aicalendarfly.com/enter/ai-appoitment-edition-edition?userbfa=' + btoa(email));
		setStoreURL('https://storebuddyai.com/app/enter/bookflowai-store-edition?user=' + btoa(email));
		setWorkerURL('https://teambuddyai.com/enter/login?token=' + btoa(email));
	}, []);

	const handleFeatureAccess = (feature) => {
		return feature ? packageAccess.includes(feature) : true;
	};

	const handleAccessDenied = (feature) => {
		const featureInfo = features.find((feat) => feat.value === feature);
		const upgradeUrl = featureInfo?.upgrade_url;

		Swal.fire({
			title: `Unlock ${featureInfo?.name || "Feature"}!`,
			text: `${featureInfo?.upgrade_title || "Upgrade your plan to access this feature."}`,
			icon: "info",
			showCancelButton: false,
			confirmButtonText: "Upgrade Now",
		}).then((result) => {
			if (result.isConfirmed) {
				window.open(upgradeUrl, "_blank");
			}
		});
	};

	const handleMenuClick = (label, feature, url, hasSubmenu, index, targetBlank) => {
		if (handleFeatureAccess(feature)) {
			setActiveMenu(label)
			if (url) {
				if (targetBlank) {
					window.open(url, "_blank");
				} else {
					navigate(url);
				}
			}
			handleItemClick(hasSubmenu, index, url);
		} else {
			handleAccessDenied(feature);
		}
	};

	const handleSubmenuClick = (e, item, feature, url, index) => {
		if (handleFeatureAccess(feature)) {
			setActiveMenu(item.label)
			navigate(url);
			handleSubmenuItemClick();
		} else {
			handleAccessDenied(feature);
		}
	};

	const handleItemClick = (hasSubmenu, index, url) => {
		if (isSidebarOpen) {
			if (isSmallScreen && !hasSubmenu) {
				setIsSidebarOpen(false);
			}
			setActiveTab((prev) => (prev === index ? null : index));
		} else {
			if (!hasSubmenu && url && isSmallScreen) {
				setIsSidebarOpen(false);
				setActiveTab(index);
			} else {
				setIsSidebarOpen(true);
				setActiveTab(index);
			}
		}
	};

	const handleSubmenuItemClick = () => {
		if (isSmallScreen) {
			setIsSidebarOpen(false);
		}
	};

	return (
		<div className={`sidebar transition ${isSidebarOpen ? "toogleOpen" : "toggleClose"}`}>
			<ul className="title mb-0 pe-0">
				{[
					{
						icon: <RiDashboardHorizontalFill />,
						label: "Dashboard",
						labelUrl: "/dashboard",
					},

					{
						icon: icons["mTBook"],
						label: "AI Talking Books",
						submenu: [
							{ title: "Create", url: "/book/create/talking_book", icon: icons["tBook"] },
							{ title: "Manage", url: "/book/manage/talking_book", icon: icons["manage"] },
						]
					},
					{
						icon: icons["mFBook"],
						label: "AI Flip Books",
						submenu: [
							{ title: "Create", url: "/book/create/flipbook", icon: icons["fBook"] },
							{ title: "Manage", url: "/book/manage/flipbook", icon: icons["manage"] },
						]
					},
					{
						icon: icons["mPBook"],
						label: "AI Photo Books",
						submenu: [
							{ title: "Create", url: "/book/create/photobook", icon: icons["pBook"] },
							{ title: "Manage", url: "/book/manage/photobook", icon: icons["manage"] },
						]
					},
					{
						icon: <GiBookCover />,
						label: "AI Book Templates",
						submenu: [
							{ title: "Create", url: "/book/template", icon: icons["cover"] },
							{ title: "Manage", url: "/manage/book/templates", icon: icons["manage"] },
						]
					},

					{ icon: <TbCloudStorm />, label: "AI Suite Edition", labelUrl: suiteURL, feature: "suite", targetBlank: "_blank" },

					{ icon: <RiTeamFill />, label: "AI Worker Edition", labelUrl: workerURL, feature: "worker", targetBlank: "_blank" },

					{ icon: <FaStore />, label: "AI Store Edition", labelUrl: storeURL, feature: "store", targetBlank: "_blank" },

					{ icon: <MdWork />, label: "AI Appointment Edition", labelUrl: appoitmentURL, feature: "appointment", targetBlank: "_blank" },


					{ icon: <FaGifts />, label: "DFY Edition", labelUrl: "/dfy", feature: "dfy" },

					{
						icon: <FaTools />,
						label: "Agency Edition",
						submenu: [
							{ title: "Create", url: "/create-agency", feature: "agency", icon: icons["create"] },
							{ title: "Manage", url: "/manage-agency", feature: "agency", icon: icons["manage"] },
						],

					},
					{
						icon: <FaHandHoldingUsd />,
						label: "Reseller Edition",
						labelUrl: "/reseller",
						feature: "reseller"
					},
					{
						icon: <FaWandSparkles />,
						label: "Whitelabel Edition",
						labelUrl: "/whitelabel",
						feature: "whitelabel"
					},

					{
						icon: <FaDesktop />,
						label: "Training Videos",
						labelUrl: "/training-videos",

					},
					{
						icon: <CiGift />,
						label: "Bonuses",
						targetBlank: "_blank",
						labelUrl: "http://getbookflowai.com/bonsues",

					},
					{
						icon: <MdOutlineSupportAgent />,
						label: "Support Desk",
						targetBlank: "_blank",
						labelUrl: "https://helpsoftdealslab.tawk.help/",
					},

					{ icon: <GiUpgrade />, label: "Upgrade Plan", labelUrl: "/upgrade" },
				].map((item, index) => (
					<li
						key={index}
						title={item.label}
						onMouseEnter={() => {
							setActiveTab(index)
							if (!isSmallScreen) {
								setIsSidebarOpen(true)
							}
						}}
					>
						<Button
							className={`w-100 text-start justify-content-start align-items-center text-capitalize ${activeTab === index || activeMenu == item.label ? "active" : ""
								}`}
							onClick={() => handleMenuClick(item.label, item.feature, item.labelUrl, !!item.submenu, index, item.targetBlank)}

						>
							<span className="icon d-flex align-items-center justify-content-center">
								{typeof item.icon === "string" ? (
									<img src={item.icon} alt={item.label} className="sidebar-icon" height={18} width={18} />
								) : (
									item.icon
								)}
							</span>
							{isSidebarOpen ? (
								<>
									<span className={activeTab === index || activeMenu == item.label ? "text-primary" : ''}>{item.label}</span>
									{item.submenu && (
										<span
											className="arrow d-flex align-items-center justify-content-center">
											<FaAngleRight />
										</span>
									)}
								</>
							) : null}
						</Button>
						{item.submenu && isSidebarOpen ? (
							<div
								className={`subMenu-wrapper transition ${activeTab === index ? "open" : "close"
									}`}
							>
								<div className="subMenu transition">
									<ul className="p-0">
										{item.submenu.map((subitem, subIndex) => (
											<li key={subIndex} className={"cursor-pointer d-flex gap-2 align-items-center"}>
												<div className="submenu-icon-container">
													<img src={subitem.icon} alt={subitem.title} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
												</div>
												<a
													// href="javascript:void(0)"
													className={`${pathname == subitem.url ? "text-primary" : ""}`}
													name={subitem.title}
													onClick={(e) =>
														handleSubmenuClick(e, item, subitem.feature, subitem.url, subIndex,)
													}
												>
													{subitem.title}
												</a>
											</li>
										))}
									</ul>
								</div>
							</div>
						) : null}
					</li>
				))}
			</ul>

			{isSidebarOpen && <div className="logout-wrapper">
				<div className="logout-box d-flex align-items-center justify-content-center">
					<Button
						variant="contained"
						onClick={handleLogout}
						className="btn btn-primary"
					>
						<FiLogOut /> Logout
					</Button>
				</div>
			</div>}
		</div >
	);
};

export default Sidebar;
